import React from 'react'
import styled from 'styled-components'
import { useDropOffLocationContext } from '../../core/application/contexts'
import { breakpoints } from '../../core/application/theme/breakpoints'
import SubmitDropoffDialog from './SubmitDropoffDialog'

const SubmitDropoff: React.FC = () => {

    const { displaySubmitDropoffScreen } = useDropOffLocationContext()

    if (displaySubmitDropoffScreen) {
        return (
            <SubmitDropoffContainer>
                <SubmitDropoffDialog/>
            </SubmitDropoffContainer>
        )
    }
    return <></>
}

const SubmitDropoffContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.color.white};
    z-index: 11;

    @media ${breakpoints.tablet} {
        background: rgba(0, 0, 0, 0.5);
    }
`

export default SubmitDropoff
